// @flow
import createCollectionReducer from './createCollectionReducer';

export type State = {|
  +loading: boolean,
  +loaded: boolean,
  +loadedCursors: { [key: string]: boolean },
  +entities: Array<string>,
|};

const initialState: State = {
  loading: false,
  loaded: false,
  loadedCursors: {},
  entities: [],
};

const livestreamEventCollectionActions = {
  add: 'ADD_LIVESTREAM_EVENT_TO_COLLECTION',
  remove: 'REMOVE_LIVESTREAM_EVENT_FROM_COLLECTION',
  fetch: 'FETCH_LIVESTREAM_EVENT_COLLECTION',
};

export default createCollectionReducer(initialState, livestreamEventCollectionActions);
